<template>
  <b-card class="mb-2" no-body>
    <b-card-header>
      <b-row align-v="center">
        <b-col cols="auto" class="mr-auto">
          <h5 class="">Виды услуг исполнителей</h5>
        </b-col>
        <b-col cols="auto">
          <b-button size="sm" variant="success" @click.stop="onAdd()" :disabled="isDisabled">
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>

    <b-table
      id="location-work-services"
      ref="location_work_services"
      class="mb-0"
      striped
      small
      thead-class="top-fixed-thead thead-light"
      table-class="text-small"
      responsive
      show-empty
      :busy.sync="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-compare="sortCompare"
      :empty-text="$t('message.common.emptyTable')"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(work_service)="row">
        <work-service-select
          id="work-service-select"
          ref="work_service_select"
          :is-disabled = "isDisabled"
          v-on:onSelect="onSelectWorkService($event, row)"
          v-bind:id = row.item.work_service_id
        />
      </template>

      <template #cell(price)="row">
        <b-form-input
          id="input-price"
          size="sm"
          :disabled="isDisabled"
          autocomplete="off"
          type="number"
          v-model.number="row.item.price">
        </b-form-input>
      </template>

      <template #cell(unit)="row">
        <unit-select
          id="input-unit"
          ref="unit_select"
          :is-disabled = "isDisabled"
          :initial-unit="row.item.unit_code"
          is-short v-on:selectUnit="onSelectUnit($event, row)" />
      </template>

      <template #cell(action)="row">
        <b-button
          variant="danger"
          size="sm"
          :disabled="isDisabled"
          @click="onRemove(row)"
        >
          <font-awesome-icon icon="trash" />
        </b-button>
      </template>
    </b-table>

    <b-card-footer footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Всего записей: <b>{{items.length}}</b>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            id="location-work-services-pagination"
            pills
            :total-rows="items.length"
            :per-page="perPage"
            v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import helpers from "../../utilites/helpers";
  import WorkServiceSelect from "../Catalogs/WorkServices/WorkServiceSelect";
  import UnitSelect from "../Catalogs/UnitSelect";

export default {
  name: "LocationWorks",
  components: { WorkServiceSelect, UnitSelect },
  mixins: [ helpers ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'work_service',
          label: 'Вид услуг',
          sortable: false
        },
        {
          key: 'price',
          label: 'Стоимость услуг',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-work-services-action',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      deleteRow: {
        id: null,
        work_service_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId, items) {
      this.items = items;
      this.locationId = locationId;
    },
    onAdd() {
      const data = {
        id: 0,
        location_id: this.locationId,
        work_service_id: 0,
        work_service_name: '',
        price: 0,
        unit_code: '539',
      };
      this.items.unshift(data);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = 'Удаление услуги исполнителя';
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.work_service_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    onSelectWorkService(workService, row) {
      if (workService != null) {
        row.item.work_service_id = workService.id;
        row.item.work_service_name = workService.name;
      } else {
        row.item.work_service_id = 0;
        row.item.work_service_name = "";
      }
    },
    // Единицы измерения
    onSelectUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    showHint() {
      this.showToast('Эти данные будут отображаться в Баланс-PRO.', 'Подсказка', 'info')
    }
  }
}
</script>

<style >
.location-work-services-action {
  width: 80px;
}

#location-work-services td {
  text-align: center;
}

#location-work-services th {
  text-align: center;
  vertical-align: middle;
}

#location-work-services-pagination {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorkServices.vue